import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorSharp } from '@mui/icons-material';
import { useParams } from 'react-router-dom';

import Button from 'components/library/Button/Button';
import InvestmentSumup from 'components/InvestmentSumup';
import PayementsForm from './PayementsForm/index';
import styles from './payements.module.css';
import * as statuses from 'store/states';

interface Props {
  investment: typeof statuses[keyof typeof statuses];
  actions: {
    getInvestmentsData: (id: number) => void;
  }
}

export default function Payements({ investment, actions }: Props) {
  const [status, setStatus] = useState((new URLSearchParams(window.location.search).get('status')?.toLowerCase() === 'cancel') ? 'ERROR' : 'IDLE');
  const { t } = useTranslation();
  const { id } = useParams();

  useEffect(() => {
    if (investment === 'IDLE') {
      actions.getInvestmentsData(parseInt(id || '0'));
    }
  }, [investment, id, actions])

  return (
    <>
      <section className={styles.content}>
        <div className={styles.row}>
          <PayementsForm />
          <InvestmentSumup disabled page="payment" />
        </div>
      </section>
      {
        (status === 'ERROR')
        && (
          <div className={styles.background}>
            <section className={styles.modal}>
              <div className={styles.error}>
                <ErrorSharp className={styles.icon} />
              </div>
              <h1 className={styles.title}>
                {t('payment.fail.title')}
              </h1>
              <p className={styles.description}>
                {t('payment.fail.description')}
              </p>
              <Button
                label={t('payment.fail.retry')}
                onButtonClick={() => setStatus('IDLE')}
                className={styles.button}
              />
            </section>
          </div>
        )
      }
    </>
  );
}
